import { FC } from "react";

import { useChatStore } from "../../../hooks/useChatStore";
import { useCapabilities } from "../../../contexts/permissions/useCapabilities";

import DropZoneWrapper from "../DropZoneWrapper";
import Column from "../core/Column";
import CategoryCards from "./CategoryCards";
import ChatInput from "../../chat/components/ChatInput";
import { DEFAULT_FILE_ACCEPT } from "../../../config/channels";

const HomePage: FC = () => {
  const chatStore = useChatStore();
  const { canUploadAttachments } = useCapabilities();

  return (
    <main className="grow flex flex-col bg-hex-gray-100 flex-col h-[calc(100%-6rem)]">
      <DropZoneWrapper
        className="h-full min-h-0 min-w-0 overflow-hidden flex flex-col items-center w-full"
        onFilesDropped={(files) => chatStore.setDroppedFiles(files as any)}
        acceptTypes={DEFAULT_FILE_ACCEPT}
        disabled={!canUploadAttachments}
      >
        <Column
          sx={{
            height: "100%",
            width: "100%",
            minHeight: 0,
            overflow: "hidden",
            justifyContent: "flex-start",
            alignItems: "stretch",
          }}
        >
          <div className="flex flex-1 min-h-0 w-full flex-col items-center overflow-y-auto">
            <CategoryCards />
          </div>

          <ChatInput />
        </Column>
      </DropZoneWrapper>
    </main>
  );
};

export default HomePage;
